import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	ElementRef, EventEmitter,
	Input,
	OnDestroy,
	OnInit, Output,
	ViewChild
} from '@angular/core';
import { ChannelsService } from 'src/app/services/channels.service';
import { MetadataService } from 'src/app/services/metadata.service';
import { Utils } from 'src/app/services/util.service';
import { PlaylistService } from 'src/app/services/playlist.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { VideoThumbSharedComponent } from '../video-thumb-shared/video-thumb-shared.component';
import { RemoteConfigService } from '../../services/remote-config.service';

@Component({
	selector: 'video-thumb-watchlist',
	templateUrl: './video-thumb-watchlist.component.html',
	styleUrls: ['./video-thumb-watchlist.component.scss']
})
export class VideoThumbWatchlistComponent extends VideoThumbSharedComponent implements OnInit, AfterViewInit, OnDestroy {

	@Input() dindex: number;
	@Output() recoverFocus = new EventEmitter<number>();

	showOptions: boolean = false;
	private holdTimeout: any;
	private isLongPress: boolean = false;
	addToPlaylistLoading: boolean = false;
	focusedElement: string = '';

	@ViewChild('playButton') playButton!: ElementRef;
  	@ViewChild('watchlistButton') watchlistButton!: ElementRef;

	constructor(
		private router: Router,
		public metadataService: MetadataService,
		public channelsService: ChannelsService,
		public utils: Utils,
        public cdr: ChangeDetectorRef,
        public readonly config: RemoteConfigService,
		private playlistService: PlaylistService) {
        super(cdr, metadataService, utils, channelsService);
	}


	redirectToVideo() {
		this.router.navigate(this.routerLink, { queryParams: { watchlist: true } });
	}

	handleKeyDown(event: KeyboardEvent): void {
		const key = this.checkXboxKey(event);

		if (key === 'Enter') {
		  if (!this.holdTimeout) {
			this.isLongPress = false;
			this.holdTimeout = setTimeout(() => {
			  this.showOptions = true;
			  this.isLongPress = true;
			  event.preventDefault();
			  event.stopPropagation();
			}, 400);
		  }
		}

		if (this.showOptions && key !== 'Enter') {
			if ((this.focusedElement == 'play' && key == 'ArrowDown') || (this.focusedElement == 'watchlist' && key == 'ArrowUp')) {

			} else {
				this.thumb.nativeElement.focus();
				this.showOptions = false;
			}
		}
	}

	handleKeyUp(event: KeyboardEvent): void {
		const key = this.checkXboxKey(event);

		if (key === 'Enter') {
		  if (this.holdTimeout) {
			clearTimeout(this.holdTimeout);
			this.holdTimeout = null;
		  }

		  if (!this.isLongPress && !this.showOptions) {
			this.redirectToVideo();
		  }

		  if (this.showOptions) {
			setTimeout(() => {
				this.playButton.nativeElement.focus();
			}, 10)
		  }
		}
	}

	addToPlaylist(media: any) {
        if (!this.addToPlaylistLoading) {
            this.addToPlaylistLoading = true;
            this.playlistService.addToPlaylist(media).subscribe({
                next: async () => {
                    this.completeWatchlistToggle(media);
                },
                error: () => {
                    this.completeWatchlistToggle(media);
                }
            });
        }
    }

    deleteFromPlaylist(media: any) {
        if (!this.addToPlaylistLoading) {
            this.addToPlaylistLoading = true;
            this.playlistService.deleteFromPlaylistNotLocally(media).subscribe({
                next: async () => {
                    this.completeWatchlistToggle(media);
                },
                error: () => {
					this.completeWatchlistToggle(media);
                }
            });
        }
    }

	completeWatchlistToggle(mediaId: number) {
		this.addToPlaylistLoading = false;
		setTimeout(() => {
			this.recoverFocus.emit(mediaId);
		}, 50);
	}

	existsInPlaylist(mediaId: number) {
        return this.playlistService.hasMediaId(mediaId);
    }
}
